import * as RadioGroupPrimitive from '@radix-ui/react-radio-group'
import { CircleIcon } from 'lucide-react'
import type { ComponentProps } from 'react'

import { cn } from '@/lib/utils'

export type RadioGroupSpacing = 'compact' | 'default'

const radioGroupSpacingClasses: Record<RadioGroupSpacing, string> = {
  compact: 'gap-2',
  default: 'gap-3',
}

export type RadioGroupProps = ComponentProps<typeof RadioGroupPrimitive.Root> & {
  spacing?: RadioGroupSpacing
}

function RadioGroup({ className, spacing = 'default', ...props }: RadioGroupProps) {
  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      data-spacing={spacing}
      className={cn('grid', radioGroupSpacingClasses[spacing], className)}
      {...props}
    />
  )
}

export type RadioGroupItemProps = ComponentProps<typeof RadioGroupPrimitive.Item> & {
  dataRadioGroupId?: string
}

function RadioGroupItem({ className, dataRadioGroupId, ...props }: RadioGroupItemProps) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      data-radio-group-id={dataRadioGroupId}
      className={cn(
        'aspect-square size-4 shrink-0 rounded-full border border-input bg-card outline-none transition-[border-color,color] data-[state=checked]:border-action focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring aria-invalid:border-destructive aria-invalid:outline-destructive disabled:cursor-not-allowed disabled:border-border disabled:bg-muted',
        className
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="relative flex items-center justify-center"
      >
        <CircleIcon className="absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2 fill-action stroke-action" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  )
}

export { RadioGroup, RadioGroupItem }
